// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Analytics from 'analytics-opencare';

// Selectors
import { updateOngoingCareNoMatch } from 'connect/actions';

import { Form } from 'opencare-crown';

import { selectOngoingCareNoMatch } from '../../../connect/selectors';
import { StepLoading } from '../../../checkout-styled-components';
import {
  selectDataLoadingUser,
  selectDataPatient,
  selectDataRequestedAppointment,
} from '../../../../../connect/selectors';

// Components

import { Div } from '../../../../../common/styles/oc-styled-components';
import SingleSelect from '../../../../common/components/SingleSelect/SingleSelect';
import {
  Title,
  Subtitle,
  OptionBlock,
} from '../../../../common/styled-components';

const analytics = new Analytics();

const careOptions = [
  {
    id: 'Yes',
    title: 'Yes',
    description: 'I am looking for a new dentist for ongoing care',
  },
  {
    id: 'No',
    title: 'No',
    description: 'I just need a one-off appointment for a specific issue',
  },
];

// Component
const OngoingCareStep = ({ handleNextStep }) => {
  const dispatch = useDispatch();

  const isLoading = useSelector(selectDataLoadingUser);
  const patient = useSelector(selectDataPatient);
  const requestedAppointment = useSelector(selectDataRequestedAppointment);
  const savedAnswer = useSelector(selectOngoingCareNoMatch);

  if (isLoading) {
    return (
      <div data-testid="loading">
        <StepLoading type="loading" />
      </div>
    );
  }

  const onSelection = (value, index) => {
    dispatch(updateOngoingCareNoMatch(value));

    analytics.trackClick({
      pageType: analytics.pageTypes.FORM,
      pageName: 'form-booking-account',
      name: 'form-booking',
      section: 'ongoing-care',
      position: [index],
      content: {
        ongoingCare: value,
      },
      practiceId: requestedAppointment.provider?.clinic,
      providerId: requestedAppointment.providerId,
      patientId: patient.id,
    });

    handleNextStep();
  };

  return (
    <div data-testid="main-reason">
      <Title id="title">
        Are you looking to join a new practice for ongoing care?
      </Title>
      <Subtitle>
        This allows the practice to structure your first appointment correctly.
      </Subtitle>
      <Div margin="20px 0 0 0">
        <Form onFinish={onSelection}>
          <OptionBlock row={3}>
            {careOptions.map((option, i) => (
              <SingleSelect
                key={option.id}
                name={option.title}
                id={option.id}
                title={option.title}
                description={option.description}
                describedBy="title"
                onChange={e => onSelection(e, i)}
                selected={option.id === savedAnswer}
              />
            ))}
          </OptionBlock>
        </Form>
      </Div>
    </div>
  );
};

OngoingCareStep.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
};

export default OngoingCareStep;
